<wsd-extended-card
  [title]="'DATA_PORTAL.CONSTITUTION.TITLE' | translate">
  <div class="text-center">
    <div class="const-icon">
      <i class="fa fa-book-alt primary-color">
        <span></span>
        <i class="fa fa-balance-scale primary-color"></i>
      </i>
    </div>
    <span class="percentage primary-color">
      {{ percentage }}%
    </span>
    <span class="lead-text">
      {{ 'DATA_PORTAL.CONSTITUTION.APPROVED' | translate }}
    </span>
  </div>
</wsd-extended-card>
